import SkipRedirect from '@/graphQlQueries/mutations/skipRedirect';

// "Redirect the old address" tick on rename/move. The DB records every URL
// change and the redirect sync turns it into a 301; unticking marks the URL
// the item just left as not redirecting. Call after the rename/move is saved.
export default {
  data: () => ({
    redirectOldUrl: true,
  }),
  methods: {
    // redirect: a bulk move passes the tick it read before closing its modal.
    async skipOldUrlRedirectIfUnticked(item, redirect = this.redirectOldUrl) {
      this.redirectOldUrl = true;
      if (redirect) return;
      try {
        await this.$apollo.mutate({ mutation: SkipRedirect, variables: { obj: item } });
      } catch (err) {
        console.error('skipRedirect failed, the old address keeps redirecting', err);
      }
    },
  },
};
